import {ConsentChangedEvent, ConsentManagementInitializedEvent} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";
import dom from "../../../../common/ts/core/dom";
import localStorage from "../../../../common/ts/core/localStorage";
import {GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY} from "./constants";

let eventBus: EventBus;

const AD_BLOCKS_SELECTOR = '.js-ad-block';

export function consentManagementInitializedEventHandler(event: WhitelabelEvent) {
    const {
        payload: {googleCookiesEnabled}
    } = event as ConsentChangedEvent

    if (googleCookiesEnabled) {
        eventBus.emit(new dom.ShowEvent({
            selector: AD_BLOCKS_SELECTOR,
        }));
    } else {
        eventBus.emit(new dom.HideEvent({
            selector: AD_BLOCKS_SELECTOR,
        }));
    }
}

export function consentChangedEventHandler(event: WhitelabelEvent) {
    const {
        payload: {googleCookiesEnabled}
    } = event as ConsentChangedEvent

    let localStorageValue;
    if (googleCookiesEnabled) {
        eventBus.emit(new dom.ShowEvent({
            selector: AD_BLOCKS_SELECTOR,
        }));
        localStorageValue = 'enabled';
    } else {
        eventBus.emit(new dom.HideEvent({
            selector: AD_BLOCKS_SELECTOR,
        }));
        localStorageValue = 'disabled';
    }

    eventBus.emit(new localStorage.SetItemEvent({
        key: GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY,
        value: localStorageValue,
    }))
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(ConsentManagementInitializedEvent.TYPE, consentManagementInitializedEventHandler);
    eventBus.subscribe(ConsentChangedEvent.TYPE, consentChangedEventHandler);
}

export default {
    init
};
